const Modal = ({ title, children, closeModal }) => {
  return (
    <div
      onClick={closeModal}
      className="fixed right-0 bottom-0 left-0 top-0 flex justify-center items-center z-30 bg-[#001C3888]"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col overflow-visible z-10 mx-12"
      >
        {title && (
          <div className="rounded-t-lg flex min-w-96 bg-gray-background justify-center items-center h-12">
            <div className="font-medium text-sm text-gray-dark_text">
              {title}
            </div>
          </div>
        )}
        <div
          className={[
            "rounded-b-lg min-w-96 max-w-max bg-white",
            !title && "rounded-t-lg",
          ].join(" ")}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
